import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { DialogTrigger } from '@radix-ui/react-dialog'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { DeleteAlbumDialog } from '../Album/Dialogs/DeleteAlbumDialog'
import type { PhotoActionHandlerActionProps } from './PhotoActionHandlers'
import { useDispatchPhotoActionMutation } from './useDispatchPhotoActionMutation'

export const ActionDeleteAlbum = observer<
  PhotoActionHandlerActionProps<'DELETE_ALBUM'>
>(function ActionDeleteAlbum({
  action,
  albumId = '',
  dispatch,
  buttonClass,
  onActionDialogClose,
  disabled = false,
}) {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const mutation = useDispatchPhotoActionMutation(
    'DELETE_ALBUM',
    {
      onSuccess: async data => {
        await data
        navigate(location.state?.backPath || '/photo/album')
      },
    },
    dispatch,
  )

  return (
    <DeleteAlbumDialog
      open={open}
      onClose={open => {
        setOpen(open)
        if (!open && onActionDialogClose) {
          onActionDialogClose(action.actionType)
        }
      }}
      onDeleteAlbum={() => albumId && mutation.mutateAsync([albumId])}
      isLoading={mutation.isPending}
      triggerElement={
        <DialogTrigger
          aria-label={action.label}
          data-testid={action.testid}
          aria-busy={mutation.isPending}
          disabled={disabled}
          key={action.actionType}
          className={buttonClass}
        >
          <PlainBrandIcon icon={action.icon} />
          <span>{action.label}</span>
        </DialogTrigger>
      }
    />
  )
})
